




















import { Vue, Component, Prop } from "vue-property-decorator";
import { IBrand } from "@/models/brands";
import { Route } from "vue-router";
import store from "@/store";
import _ from "@/boot/lodash";
import { CreateElement, RenderContext, VNodeData } from "vue";

enum FallbackOptions {
  ICON = "icon",
  TEXT = "text"
}

@Component
export default class BrandLogo extends Vue {
  // Props

  @Prop({ default: () => store.state.brand })
  public brand!: IBrand;

  @Prop({ default: "3rem" })
  public size!: string;

  @Prop({ default: 200 })
  public readonly quality!: 50 | 100 | 200 | 300 | 400;

  @Prop({ default: "router-link" })
  public tag!: "div" | "span" | "router-link";

  @Prop({ default: () => ({ path: "/" }) })
  public to!: Route;

  @Prop({
    default: FallbackOptions.ICON,
    validator: val => _.values(FallbackOptions).includes(val)
  })
  public fallback!: FallbackOptions;

  // Computed

  public get component() {
    const vNodeData = {
      style: { fontSize: this.size },
      class: ["u-brand-logo", this.showText && "has-text-fallback"]
    } as VNodeData;
    return {
      functional: true,
      render: (h: CreateElement, { children }: RenderContext) =>
        this.tag === "router-link"
          ? h(this.tag, { ...vNodeData, props: { to: this.to } }, children)
          : h(this.tag, vNodeData, children)
    };
  }

  public get brandName() {
    return this.brand?.name;
  }

  public get brandImageSrc() {
    return (
      this.brand?.image?.full_url +
      (this.quality ? `?size=${this.quality}x${this.quality}` : "")
    );
  }

  public get showImage() {
    return !!this.brand?.image?.full_url;
  }

  public get showIcon() {
    return this.fallback === FallbackOptions.ICON;
  }

  public get showText() {
    return !this.showImage && !this.showIcon;
  }

  public get initials() {
    const name = this.brandName
      .replace(/[^a-zA-Z0-9 ]/g, "")
      .trim()
      .split(" ");
    if (name.length > 1) {
      const first = this.$_.first(this.$_.first(name)) || "";
      const last = this.$_.first(this.$_.last(name)) || "";
      return `${first + last}`.toUpperCase();
    }
    return name[0].substring(0, 2).toUpperCase();
  }
}
